import Vue from "vue";
import VueRouter from "vue-router";
import authenticate from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    name: "login",
    meta: {
      title: "Login"
    },
    component: () => import("@/views/Login")
  },
  {
    path: "/terms",
    name: "terms",
    meta: {
      title: "Terms"
    },
    component: () => import("@/views/Terms")
  },
  {
    path: "/privacy",
    name: "privacy",
    meta: {
      title: "Policies Privacy"
    },
    component: () => import("@/views/PoliciesPrivacy")
  },
  {
    path: "/delete_account",
    name: "delete_account",
    meta: {
      title: "Delete Account"
    },
    component: () => import("@/views/FormDeleteAccount")
  },
  {
    path: "/admin",
    component: () => import("@/views/Admin/index.vue"),
    meta: {
      title: "Admin",
      requiresAuth: true
    },
    children: [
      {
        path: "",
        name: "admin",
        meta: {
          title: "Login"
        },
        component: () => import("@/views/Login")
      },
      {
        path: "profile",
        name: "profile",
        meta: {
          title: "Profile",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/profile/edit.vue")
      },
      {
        path: "settings",
        name: "settings",
        meta: {
          title: "Setting",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/settings/edit.vue")
      },
      {
        path: "not_found",
        name: "not_found",
        meta: {
          title: "Not Found",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/settings/not_found.vue")
      },
      //Users
      {
        path: "users",
        name: "users",
        meta: {
          title: "Users",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/users/list.vue")
      },
      {
        path: "users/edit/:id",
        name: "users-edit",
        meta: {
          title: "Edit User",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/users/form.vue")
      },
      {
        path: "users/add",
        name: "users-add",
        meta: {
          title: "Add User",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/users/form.vue")
      },
      //Product Price
      {
        path: "notification_prices",
        name: "notification_prices",
        meta: {
          title: "Notification Prices",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/notification_prices/list.vue")
      },
      {
        path: "notification_prices/edit/:id",
        name: "notification_prices-edit",
        meta: {
          title: "Edit Notification Price",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/notification_prices/form.vue")
      },
      {
        path: "notification_prices/add",
        name: "notification_prices-add",
        meta: {
          title: "Add Notification Price",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/notification_prices/form.vue")
      },
      //Users
      {
        path: "enterprises",
        name: "enterprises",
        meta: {
          title: "Enterprises",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/enterprises/list.vue")
      },
      {
        path: "enterprises/edit/:id",
        name: "enterprises-edit",
        meta: {
          title: "Edit Enterprise",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/enterprises/form.vue")
      },
      {
        path: "enterprises/add",
        name: "enterprises-add",
        meta: {
          title: "Add Enterprise",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/enterprises/form.vue")
      },

      //Guards
      {
        path: "guards",
        name: "guards",
        meta: {
          title: "Guards",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/guards/list.vue")
      },
      {
        path: "guards/edit/:id",
        name: "guards-edit",
        meta: {
          title: "Edit Guard",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/guards/form.vue")
      },
      {
        path: "guards/add",
        name: "guards-add",
        meta: {
          title: "Add Guard",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/guards/form.vue")
      },
      //order_notes
      {
        path: "user/:user_id/order_notes",
        name: "user-orders",
        meta: {
          title: "Order Note",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/users/orders/order_notes/list.vue")
      },
      //orders
      {
        path: "users/:user_id/orders",
        name: "user-orders",
        meta: {
          title: "Company Product",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/users/orders/list.vue")
      },
      {
        path: "users/:user_id/orders/edit/:id",
        name: "user-orders-edit",
        meta: {
          title: "Edit Company Product",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/users/orders/form.vue")
      },
      {
        path: "users/:user_id/orders/add",
        name: "user-orders-add",
        meta: {
          title: "Add Company Product",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/users/orders/form.vue")
      },
      // Reports
      {
        path: "reports",
        name: "reports",
        meta: {
          title: "Report",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/reports/report.vue")
      },
      // Insight
      {
        path: "insights",
        name: "insights",
        meta: {
          title: "Insight",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/insights/insight.vue")
      },
      // Insight users
      {
        path: "insights/keep-track-users",
        name: "insights-users",
        meta: {
          title: "Insight",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/insights/keep-track-users.vue")
      },
      //Faqs
      {
        path: "faqs",
        name: "faqs",
        meta: {
          title: "Faqs",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/faqs/list.vue")
      },
      {
        path: "faqs/edit/:id",
        name: "faqs-edit",
        meta: {
          title: "Edit Faq",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/faqs/form.vue")
      },
      {
        path: "faqs/add",
        name: "faqs-add",
        meta: {
          title: "Add Faq",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/faqs/form.vue")
      },
      //Terms
      {
        path: "terms",
        name: "terms-cms",
        meta: {
          title: "Terms",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/terms/list.vue")
      },
      {
        path: "terms/edit/:id",
        name: "terms-edit",
        meta: {
          title: "Edit Term",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/terms/form.vue")
      },
      {
        path: "terms/add",
        name: "terms-add",
        meta: {
          title: "Add Term",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/terms/form.vue")
      },
      //Privacies
      {
        path: "privacies",
        name: "privacies",
        meta: {
          title: "Privacy",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/privacies/list.vue")
      },
      {
        path: "privacies/edit/:id",
        name: "privacies-edit",
        meta: {
          title: "Edit Privacy",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/privacies/form.vue")
      },
      {
        path: "privacies/add",
        name: "privacies-add",
        meta: {
          title: "Add Privacy",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/privacies/form.vue")
      },
      //Notifications
      {
        path: "push_notifications",
        name: "push_notifications",
        meta: {
          title: "Notifications",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/push_notifications/list.vue")
      },
      {
        path: "push_notifications/edit/:id",
        name: "push_notifications-edit",
        meta: {
          title: "Edit Notification",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/push_notifications/form.vue")
      },
      {
        path: "push_notifications/add",
        name: "push_notifications-add",
        meta: {
          title: "Add Notification",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/push_notifications/form.vue")
      },
      //Notifications
      {
        path: "user_push_notifications",
        name: "user_push_notification",
        meta: {
          title: "User Notifications",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/user_push_notifications/list.vue")
      },
      /*{
        path: "push_notifications/edit/:id",
        name: "push_notifications-edit",
        meta: {
          title: "Edit Notification",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/push_notifications/form.vue")
      },
      {
        path: "push_notifications/add",
        name: "push_notifications-add",
        meta: {
          title: "Add Notification",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/push_notifications/form.vue")
      },*/
      //Time lines
      {
        path: "timelines",
        name: "timelines",
        meta: {
          title: "Time Line",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/timelines/list.vue")
      },
      {
        path: "timelines/edit/:id",
        name: "timelines-edit",
        meta: {
          title: "Edit Time Line",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/timelines/form.vue")
      },
      {
        path: "timelines/add",
        name: "timelines-add",
        meta: {
          title: "Add Time Line",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/timelines/form.vue")
      },
      //families
      {
        path: "families",
        name: "families",
        meta: {
          title: "Family Line",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/families/list.vue")
      },
      {
        path: "families/edit/:id",
        name: "families-edit",
        meta: {
          title: "Edit Family Line",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/families/form.vue")
      },
      {
        path: "families/add",
        name: "families-add",
        meta: {
          title: "Add Family Line",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/families/form.vue")
      },
      //discovers
      {
        path: "discovers",
        name: "discovers",
        meta: {
          title: "Discover Line",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/discovers/list.vue")
      },
      {
        path: "discovers/edit/:id",
        name: "discovers-edit",
        meta: {
          title: "Edit Discover Line",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/discovers/form.vue")
      },
      {
        path: "discovers/add",
        name: "discovers-add",
        meta: {
          title: "Add Discover Line",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/discovers/form.vue")
      },
      //moments
      {
        path: "moments",
        name: "moments",
        meta: {
          title: "Moment Line",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/moments/list.vue")
      },
      {
        path: "moments/edit/:id",
        name: "moments-edit",
        meta: {
          title: "Edit Moment Line",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/moments/form.vue")
      },
      {
        path: "moments/add",
        name: "moments-add",
        meta: {
          title: "Add Moment Line",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/moments/form.vue")
      },
      //categories
      {
        path: "categories",
        name: "categories",
        meta: {
          title: "Category",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/categories/list.vue")
      },
      {
        path: "categories/edit/:id",
        name: "categories-edit",
        meta: {
          title: "Edit Category",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/categories/form.vue")
      },
      {
        path: "categories/add",
        name: "categories-add",
        meta: {
          title: "Add Category",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/categories/form.vue")
      },
      //coupons
      {
        path: "coupons",
        name: "coupons",
        meta: {
          title: "Coupon",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/coupons/list.vue")
      },
      {
        path: "coupons/edit/:id",
        name: "coupons-edit",
        meta: {
          title: "Edit Coupon",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/coupons/form.vue")
      },
      {
        path: "coupons/add",
        name: "coupons-add",
        meta: {
          title: "Add Coupon",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/coupons/form.vue")
      },
        //
      {
        path: "coupons_enterprises/edit/:id",
        name: "coupons-enterprises-edit",
        meta: {
          title: "Edit Coupon",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/coupons/form.vue")
      },
      {
        path: "coupons_enterprises/add",
        name: "coupons-enterprises-add",
        meta: {
          title: "Add Coupon",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/coupons/form.vue")
      },
      //companies
      {
        path: "companies",
        name: "companies",
        meta: {
          title: "Category",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/companies/list.vue")
      },
      {
        path: "companies/edit/:id",
        name: "companies-edit",
        meta: {
          title: "Edit Category",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/companies/form.vue")
      },
      {
        path: "companies/add",
        name: "companies-add",
        meta: {
          title: "Add Category",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/companies/form.vue")
      },

      //product
      {
        path: "companies/:company_id/products",
        name: "company-products",
        meta: {
          title: "Company Products",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/companies/products/list.vue")
      },
      {
        path: "companies/:company_id/products/edit/:id",
        name: "company-product-edit",
        meta: {
          title: "Edit companies Product",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/companies/products/form.vue")
      },
      {
        path: "companies/:company_id/products/add",
        name: "company-product-add",
        meta: {
          title: "Add company Product",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/companies/products/form.vue")
      },

      //Prices
      {
        path: "companies/:company_id/products/:product_id/product_prices",
        name: "company-products-prices",
        meta: {
          title: "Company Product Prices ",
          requiresAuth: true
        },
        component: () =>
          import("@/views/Admin/companies/products/prices/list.vue")
      },
      {
        path: "companies/:company_id/products/:product_id/prod_prices/edit/:id",
        name: "company-product-price-edit",
        meta: {
          title: "Edit Product Price",
          requiresAuth: true
        },
        component: () =>
          import("@/views/Admin/companies/products/prices/form.vue")
      },
      {
        path: "companies/:company_id/products/:product_id/prod_prices/add",
        name: "company-product-price-add",
        meta: {
          title: "Add Product Price",
          requiresAuth: true
        },
        component: () =>
          import("@/views/Admin/companies/products/prices/form.vue")
      },

      //guards
      {
        path:
          "companies/:company_id/regions/:region_id/stores/:store_id/guards",
        name: "store-guards",
        meta: {
          title: "Store Guard",
          requiresAuth: true
        },
        component: () =>
          import("@/views/Admin/companies/regions/stores/guards/list.vue")
      },
      {
        path:
          "companies/:company_id/regions/:region_id/stores/:store_id/guards/edit/:id",
        name: "store-guards-edit",
        meta: {
          title: "Edit Store Guard",
          requiresAuth: true
        },
        component: () =>
          import("@/views/Admin/companies/regions/stores/guards/form.vue")
      },
      {
        path:
          "companies/:company_id/regions/:region_id/stores/:store_id/guards/add",
        name: "store-guards-add",
        meta: {
          title: "Add Store Guard",
          requiresAuth: true
        },
        component: () =>
          import("@/views/Admin/companies/regions/stores/guards/form.vue")
      },
      //order products
      {
        path: "users/:user_id/orders/:order_id/order_products",
        name: "order-products",
        meta: {
          title: "Order Product",
          requiresAuth: true
        },
        component: () =>
          import("@/views/Admin/users/orders/order_products/list.vue")
      },
      {
        path: "users/:user_id/orders/:order_id/order_products/edit/:id",
        name: "order-products-edit",
        meta: {
          title: "Edit Order Product",
          requiresAuth: true
        },
        component: () =>
          import("@/views/Admin/users/orders/order_products/form.vue")
      },
      {
        path: "users/:user_id/orders/:order_id/order_products/add",
        name: "order-products-add",
        meta: {
          title: "Add Order Product",
          requiresAuth: true
        },
        component: () =>
          import("@/views/Admin/users/orders/order_products/form.vue")
      },
      //regions
      {
        path: "companies/:company_id/regions",
        name: "company-regions",
        meta: {
          title: "Company Region",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/companies/regions/list.vue")
      },
      {
        path: "companies/:company_id/regions/edit/:id",
        name: "company-regions-edit",
        meta: {
          title: "Edit Company Region",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/companies/regions/form.vue")
      },
      {
        path: "companies/:company_id/regions/add",
        name: "company-regions-add",
        meta: {
          title: "Add Company Region",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/companies/regions/form.vue")
      },
      //stores
      {
        path: "companies/:company_id/regions/:region_route_id/stores",
        name: "company-stores",
        meta: {
          title: "Company Product",
          requiresAuth: true
        },
        component: () =>
          import("@/views/Admin/companies/regions/stores/list.vue")
      },
      {
        path: "companies/:company_id/regions/:region_id/stores/edit/:id",
        name: "company-stores-edit",
        meta: {
          title: "Edit Company Product",
          requiresAuth: true
        },
        component: () =>
          import("@/views/Admin/companies/regions/stores/form.vue")
      },
      {
        path: "companies/:company_id/regions/:region_id/stores/add",
        name: "company-stores-add",
        meta: {
          title: "Add Company Product",
          requiresAuth: true
        },
        component: () =>
          import("@/views/Admin/companies/regions/stores/form.vue")
      },
      //memberships
      {
        path: "companies/:company_id/member_affiliations",
        name: "company-memberships",
        meta: {
          title: "Company Membership",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/companies/memberships/list.vue")
      },
      {
        path: "companies/:company_id/member_affiliations/edit/:id",
        name: "company-memberships-edit",
        meta: {
          title: "Edit Company Membership",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/companies/memberships/form.vue")
      },
      {
        path: "companies/:company_id/member_affiliations/add",
        name: "company-memberships-add",
        meta: {
          title: "Add Company Membership",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/companies/memberships/form.vue")
      },
      //product prices
      {
        path: "companies/:company_id/regions/:region_route_id/product_prices",
        name: "company-product_prices",
        meta: {
          title: "Company Membership",
          requiresAuth: true
        },
        component: () =>
          import("@/views/Admin/companies/regions/product_prices/list.vue")
      },
      //ratings
      {
        path:
          "companies/:company_id/regions/:region_id/stores/:store_id/ratings",
        name: "company-ratings",
        meta: {
          title: "Company Membership",
          requiresAuth: true
        },
        component: () =>
          import("@/views/Admin/companies/regions/stores/ratings/list.vue")
      },
      {
        path:
          "companies/:company_id/regions/:region_id/stores/:store_id/ratings/edit/:id",
        name: "company-ratings-edit",
        meta: {
          title: "Edit Company Membership",
          requiresAuth: true
        },
        component: () =>
          import("@/views/Admin/companies/regions/stores/ratings/form.vue")
      },
      {
        path:
          "companies/:company_id/regions/:region_id/stores/:store_id/ratings/add",
        name: "company-ratings-add",
        meta: {
          title: "Add Company Membership",
          requiresAuth: true
        },
        component: () =>
          import("@/views/Admin/companies/regions/stores/ratings/form.vue")
      },
      //products
      {
        path:
          "companies/:company_id/regions/:region_id/stores/:store_id/products",
        name: "company-Store-Products",
        meta: {
          title: "Company Store Product",
          requiresAuth: true
        },
        component: () =>
          import("@/views/Admin/companies/regions/stores/products/list.vue")
      },
      {
        path:
          "companies/:company_id/regions/:region_id/stores/:store_id/products/edit/:id",
        name: "company-Store-Products-edit",
        meta: {
          title: "Edit Company Store Product",
          requiresAuth: true
        },
        component: () =>
          import("@/views/Admin/companies/regions/stores/products/form.vue")
      },
      {
        path:
          "companies/:company_id/regions/:region_id/stores/:store_id/products/add",
        name: "company-Store-Products-add",
        meta: {
          title: "Add Company Store Product",
          requiresAuth: true
        },
        component: () =>
          import("@/views/Admin/companies/regions/stores/products/form.vue")
      },
      //sales
      {
        path: "sales",
        name: "sales",
        meta: {
          title: "Sales Line",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/sales/list.vue")
      },
      {
        path: "sales/edit/:id",
        name: "sales-edit",
        meta: {
          title: "Edit Sales Line",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/sales/form.vue")
      },
      {
        path: "sales/show/:id",
        name: "sales-show",
        meta: {
          title: "Detail Sales Line",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/sales/show.vue")
      },
      {
        path: "sales/add",
        name: "sales-add",
        meta: {
          title: "Add Sales Line",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/sales/form.vue")
      },
      {
        path: "update-password",
        name: "update_password",
        meta: {
          title: "Update Password",
          requiresAuth: true
        },
        component: () => import("@/views/Admin/update_password/index.vue")
      },
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.NODE_ENV === "production" ? "admin" : "/",
  routes
});

router.beforeEach((toRoute, fromRoute, next) => {
  window.document.title =
    "Instalane - " +
    (toRoute.meta && toRoute.meta.title ? toRoute.meta.title : "Home");

  if (toRoute.matched.some(record => record.meta.requiresAuth)) {
    if (authenticate.getters["Authenticate/isLoggedIn"]) {
      next();
      return;
    }
    next("/");
  } else if (
    (toRoute.name === "admin" || toRoute.name === "login") &&
    authenticate.getters["Authenticate/isLoggedIn"]
  ) {
    if(localStorage.role && localStorage.role==="admin_enterprise"){
      router.push("/admin/reports");
    }else {
      router.push("/admin/users");
    }
    return;
  } else {
    next();
  }
});

export default router;
